<template>
<div class="wrap sunhomedetail-wrap flex-column">
    <mu-infinite-scroll :loading="load" loadingText="拼命加载中" class="load" v-if="load"/>
    <div class="flex-item" v-else>
      <!-- banner广告轮播 -->
      <div class="banner" v-if="ShareInfoContent.shareImages.length >0">
        <swiper :options="swiperOption" ref="mySwiper1">
          <!-- 轮播图 -->
          <swiper-slide v-for="(item,index) in ShareInfoContent.shareImages" :key="index">
            <div class="img-box">
              <v-image :width="720" :imagePath="item.imagePath"></v-image>
            </div>
          </swiper-slide>
          <!-- 轮播切换 -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="evaluate-detail">
        <div class="evaluate-item">
          <div class="user-info">
            <span class="head">

              <img src="/static/images/head_default_3x.png">
              <!-- <v-image :imagePath="require('@assets/zyImages/u276.jpeg')"></v-image> -->
            </span>
            <div class="content">
              <p class="name">{{ShareInfoContent.shareBy}}</p>
              <p class="time">
                <span class="floatL">{{ShareInfoContent.shareTime}}</span>

                <div class="clearfix"></div>
              </p>
            </div>
          </div>
          <div class="evaluate-content">{{ShareInfoContent.shareContent}}</div>
        </div>
      </div>
      <div v-if='ShareInfoContent.shareGoods !=null && ShareInfoContent.shareGoods.length>0'>
        <p class="title">商品信息</p>
        <div class="button" v-for='item in ShareInfoContent.shareGoods' @click="viewGoodsDetail(item)">
          <span><label class="goodsTitle ellipsis">{{item.goodsName}}</label><label class="red">￥{{item.goodsPrice}}</label><label class="scandetail">查看详情</label></span>
        </div>
      </div>
      
    </div>
  </div>
</template>
<script type="text/javascript">
import image from '@components/image/image';
import { mapActions, mapGetters } from 'vuex';
export default {
  data() {
    return {
      load:true,
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true  
        /*notNextTick: true,  */
        pagination: '.swiper-pagination',
        autoplay: 10000,
        autoplayDisableOnInteraction: false
      },
      shareId:this.$route.query.shareId,//shareId
      ShareInfoContent:{}
    }
  },

  methods: {
    ...mapActions({
      getShareInfoContent:'getShareInfoContent',
    }),
    //浏览商品详情
    viewGoodsDetail(goods) {
      if (goods && goods.goodsId) {
        this.$router.push({
          path: '/main/goodsDetail?goodsId=' + goods.goodsId + '&skuId=' + (goods.skuId || 0) + '&storeId=' + goods.storeId
        })
      }
    },
  },
  components: {
    'v-image': image,
  },
  created() {
    //  1.获取详情
    this.getShareInfoContent([this.shareId]).then(res => {
      this.load = false;
      console.log('getShareInfoContent', res);
      this.ShareInfoContent = res;
    });
  },
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'src/common/sass/mixin.scss';
.sunhomedetail-wrap{
  .banner {
    min-height: 0.5rem;
    .swiper-pagination {
      width: 100%;
      bottom: 0.275rem;
      text-align: center;
      >span {
        width: 0.15rem;
        height: 0.15rem;
        margin: 0 0.075rem;
        border-radius: 50%;
        background: #fff;
        opacity: 1;
        &.swiper-pagination-bullet-active {
          width: 0.3rem;
          border-radius: 0.2rem;
        }
      }
    }
  }
  .evaluate-detail{
      margin-top: 1px;
      padding: 0.25rem 0.35rem;
      background: #fff;
      word-break: break-all;
      .evaluate-item{
        border-bottom: 2px solid #E5E5E5;
        margin: 0.3rem 0 0rem 0;
        &:last-child{
          border-bottom: 0;
        }
        .user-info{
          position: relative;
          margin-bottom: 0.3rem;
          .head{
            display: inline-block;
            width: 0.8rem;
            height: 0.8rem;
            border-radius: 50%;
            overflow: hidden;
            img{
              width: 100%;
            }
          }
          .content{
            position: absolute;
            left:1.0rem;
            right: 0;
            top: 0;
            >p{
              @include font-dpr(12px);
              color: #434343;
              &.time{
                color: #B2B2B2;
              }
            }
            .star{
              display: inline-block;
              width: 0.3rem;
              height: 0.3rem;
              margin-left: 0.125rem;
              background: url(/static/images/star_gray_3x.png) no-repeat center;
              background-size: cover;
              &.active{
                background: url(/static/images/star_red_3x.png) no-repeat center;
                background-size: cover;
              }
            }
          }
        }
        .evaluate-content{
          color: #333333;
          line-height: 1.5;
          text-align: justify;
        }
        .merchant-reply{
          padding: 0.25rem;
          padding-bottom: 1px;
          background: #F0F0F0;
          border-radius: 0.125rem;
          margin-bottom: 0.375rem;
          .header{
            margin-bottom: 0.25rem;
            >span{
              color: #E60012;
              &.time{
                color: #B2B2B2;
              }
            }
          }
        }
      }
  }
  p.title{
    padding: 0.25rem 0.35rem 0.25rem 0.35rem;
    color: #999999;
  }
  .button{
      margin-top: 2px;
      color:#333333 ;
      padding: 0.45rem 0.75rem 0.45rem 0.35rem;
      background: #fff;
      position: relative;
      @include font-dpr(14px);
      @include arrow(#999999, right, 0.2rem, 1px, 0.35rem);
      label.goodsTitle{
        width: 50%;
        display: inline-block;
      }
      .scandetail{
        float: right;
        color: #999999;
        @include font-dpr(12px);
      }
      .red{
        color: #E60012;
        margin-left: 0.25rem;
      }
    }
}

</style>



// WEBPACK FOOTER //
// sunhomedetail.vue?359b4c2d